// extracted by mini-css-extract-plugin
export var defaultWrapper = "_f8-3";
export var downloadButton = "_f8-4";
export var fileContainer = "_f8-9 _f8-7";
export var fileContainerBase = "_f8-7";
export var fileContainerFixedHeight = "_f8-8 _f8-7";
export var fileInfo = "_f8-5";
export var fileInfoWidthRestricted = "_f8-6";
export var fileType = "_f8-1";
export var fileTypeName = "_f8-2";
export var image = "_f8-0";
export var link = "_f8-b";
export var overflowEllipsis = "_f8-a";